import React from 'react';
import ValorMonetario from './ValorMonetario';

const FormaPagamento = ({ pedido }) => {
  if (!pedido) return null; // Evita renderizar se não veio nada
  return (
    <>
      <div className="row">
        <div className="col-md-12">
            <a href={pedido.boleto_pdf} target='_blank' className="btn-main color-2">
                Ver Boleto
            </a>
        </div>
        <br/><br/>
        <div className="col-md-12">
            <h4>Pedido n° {(pedido.transacao_id) ?? 'Não disponível'}</h4>
        </div>
        <div className="col-md-2">
            <p>Valor: <br /><ValorMonetario valor={pedido.valor || 0} /></p>
        </div>
        <div className="col-md-6">
            <p>Pix Copia e Cola: <br />{pedido.pix_codigo_pagamento }</p>
        </div>
        <div className="col-md-4">
            <p><img src={pedido.link_imagem_qrcode } width="200" alt="QR Code Pix" /></p>
        </div>
      </div>
    </>
  );
};

export default FormaPagamento;